import { shopifyOverrides } from "./shopify";
import type { Language } from "../types";

export type StyleOverrideMap = Record<string, Record<string, { en: string; th: string }>>;

export const styleOverrides: StyleOverrideMap = {
  shopify: shopifyOverrides,
  // Future: apple: appleOverrides,
};

/**
 * Get style override for a field.
 * 
 * @param doctype - The DocType name (e.g., "Item", "Sales Order")
 * @param fieldname - The field name (e.g., "item_code")
 * @param style - The experience style (e.g., "shopify")
 * @param language - The language code ("en" | "th")
 * @returns The override label or null if not found
 */
export function getStyleOverride(
  doctype: string,
  fieldname: string,
  style: string,
  language: Language
): string | null {
  const overrides = styleOverrides[style];
  if (!overrides) return null;
  
  const key = `${doctype}:${fieldname}`;
  const override = overrides[key];
  if (!override) return null;
  
  return override[language] || null;
}

